import { EventDispatcher } from 'three';
import { autoInjectable, singleton } from 'tsyringe';

// All events that can be dispatched by EventBus
// This is to make EventDispatcher generic
// https://threejs.org/docs/#api/en/core/EventDispatcher
export interface EventBusEventMap {
    loadingStart: {};
    loadingEnd: {};
    model3dVisibilityChanged: {};
    model3dRemovedFromScene: {};
    model3dAddedToScene: {};
    demoRequestPopup: {};
    demoStart: {};
    demoAvailabilityChange: { isAvailable: boolean };
    janusVideoroomEvent: any;
    janusTalkingEvent: any;
    janusUnpublishedEvent: any;
    janusPublishedEvent: any;
    janusOnLocalTrack: any;
    janusOnRemoteTrack: any;
    janusLeaving: any;
    janusJoined: any;
    janusOnCleanup: any;
    janusConfigured: any;
}

@singleton()
@autoInjectable()
export default class EventBus extends EventDispatcher<EventBusEventMap> {
    public sendLoadingStart() {
        this.dispatchEvent({ type: 'loadingStart' });
    }
    public sendLoadingEnd() {
        this.dispatchEvent({ type: 'loadingEnd' });
    }
}
